<script lang="ts">
    import { Button, ButtonGroup, Icon, Input, Label } from "sveltestrap";
    import { v4 as v4uuid } from "uuid";
    import { Link, navigate } from "svelte-navigator";
    import { parentsService, thirdsService } from '../services';
    import AddThirdModal from "./AddThirdModal.svelte";
    import { Parent } from "../Model/Parent";
import ParamSelect from "./ParamSelect.svelte";

    export let thirId: string;

    let parents: any[];
    let addKinship: boolean = false;
    let openModal = false;

    $: loadParents(thirId);

    async function loadParents(thirId: string): Promise<void> {
        if (!thirId) {
            navigate('/');
            return;
        }

        parents = await parentsService.findbyThird(thirId);

        for (const parent of parents) {
            parent.edit = false;
        }

        parents.sort((a,b) => {
            return a.param.name < b.param.name ? -1 : 1;
        })
        
    }

    async function addNewThird(event){

        const third = await thirdsService.findOne(event.detail);

        const newParent:any = {
            third: third,
            kinship: {
                id: v4uuid(),
                paramId: null,
                returnUserId: event,
                userId: thirId
            },
            edit: true
        }

        parents.push(newParent);

        parents = parents;

        // await parentsService.saveParent(newParent)

        // loadParents(thirId)
    }

    async function saveParent(parent){

        await parentsService.saveParent(parent.kinship)

        parent.edit = false;

        loadParents(thirId)

    }

    async function removeParent(parent){

        if (!confirm('¿Esta seguro de eliminar la relación?')) return;

        await parentsService.removeParent(parent.kinship)

        loadParents(thirId)

    }

    async function newParent(){
        openModal = true
    }

    function toggleModal(){
        addKinship = !addKinship;
    }

</script>

<style>

</style>

{#if parents}
    <div class="row">
        <div class="col-12 mt-3 mb-3">
            <div class="text-end">
                <Button color="primary" on:click={() => newParent()}>
                   Nueva Relación
                </Button>
            </div>
        </div>
        <div class="col-12">
            {#if parents?.length}
            <table class="table">
                <thead>
                    
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Nombre</th>
                            <th scope="col">DNI</th>
                            <th scope='col'>Relación</th>
                            <th scope='col'></th>
                        </tr>
            
                </thead>
                <tbody>
                    {#each parents as parent, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                <Link to="/tercero/{parent.third.id}">
                                    {parent.third.name} {parent.third.surname1} {#if parent.third.surname2}{parent.third.surname2}{/if}
                                </Link>
                            </td>
                            <td>{parent.third.document}</td>
                            <td>
                                {#if !parent.edit}
                                    <span>{parent.param.name}</span>
                                {:else}
                                    <ParamSelect
                                        bind:paramSelectId = {parent.kinship.paramId}
                                        paramType = 'kinshipRelation'
                                        nothing = {true}
                                    />
                                {/if}
                            </td>
                            <td class="text-end">
                                <ButtonGroup>
                                    {#if !parent.edit}
                                        <Button color="warning" on:click={() => { parent.edit = true }}><Icon name="pencil-square" /></Button>
                                    {:else}
                                        <Button color="success" on:click={() => saveParent(parent)}><Icon name="check2" /></Button>
                                    {/if}
                                    <Button color="danger" on:click={() => removeParent(parent)}><Icon name="x" /></Button>
                                  </ButtonGroup>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay Relaciones para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
{/if}

<AddThirdModal open={openModal} toggle={toggleModal} {thirId} on:changeThird={(event) => addNewThird(event.detail)} />

